import api from './api';

// Auth APIs
export const authAPI = {
  signup: async (userData) => {
    const response = await api.post('/auth/signup', userData);
    return response.data;
  },
  
  login: async (credentials) => {
    const response = await api.post('/auth/login', credentials);
    return response.data;
  },
  
  getCurrentUser: async () => {
    const response = await api.get('/auth/me');
    return response.data;
  },
  
  updateProfile: async (profileData) => {
    const response = await api.put('/auth/me', profileData);
    return response.data;
  },
  
  forgotPassword: async (email) => {
    const response = await api.post('/auth/forgot-password', { email });
    return response.data;
  },
  
  resetPassword: async (token, newPassword) => {
    const response = await api.post('/auth/reset-password', { token, newPassword });
    return response.data;
  },
};

// User APIs
export const userAPI = {
  getStats: async () => {
    const response = await api.get('/user/stats');
    return response.data;
  },
  
  getReferralLink: async () => {
    const response = await api.get('/user/referral-link');
    return response.data;
  },
  
  getTransactions: async () => {
    const response = await api.get('/user/transactions');
    return response.data;
  },
  
  getEarningsChart: async (period = 'weekly') => {
    const response = await api.get(`/user/earnings-chart?period=${period}`);
    return response.data;
  },
  
  getRecentActivity: async () => {
    const response = await api.get('/user/recent-activity');
    return response.data;
  },
  
  getNotifications: async () => {
    const response = await api.get('/user/notifications');
    return response.data;
  },
  
  markNotificationRead: async (notificationId) => {
    const response = await api.put(`/user/notifications/${notificationId}/read`);
    return response.data;
  },
  
  markNotificationUnread: async (notificationId) => {
    const response = await api.put(`/user/notifications/${notificationId}/unread`);
    return response.data;
  },
  
  getPerformanceComparison: async () => {
    const response = await api.get('/user/performance-comparison');
    return response.data;
  },
  
  createOrder: async (orderData) => {
    const response = await api.post('/user/orders', orderData);
    return response.data;
  },
  
  getOrders: async () => {
    const response = await api.get('/user/orders');
    return response.data;
  },
  
  createMessage: async (messageData) => {
    const response = await api.post('/user/messages', messageData);
    return response.data;
  },
  
  getMessages: async () => {
    const response = await api.get('/user/messages');
    return response.data;
  },
};

// Admin Auth APIs
export const adminAuthAPI = {
  login: async (credentials) => {
    const response = await api.post('/admin/auth/login', credentials);
    return response.data;
  },
  
  getCurrentAdmin: async () => {
    const response = await api.get('/admin/auth/me');
    return response.data;
  },
};

// Admin APIs
export const adminAPI = {
  getStats: async () => {
    const response = await api.get('/admin/stats');
    return response.data;
  },
  
  getAllUsers: async () => {
    const response = await api.get('/admin/users');
    return response.data;
  },
  
  updateUser: async (userId, userData) => {
    const response = await api.put(`/admin/users/${userId}`, userData);
    return response.data;
  },
  
  deleteUser: async (userId) => {
    const response = await api.delete(`/admin/users/${userId}`);
    return response.data;
  },
  
  sendResetPasswordEmail: async (userEmail) => {
    const response = await api.post('/admin/send-reset-password', { email: userEmail });
    return response.data;
  },
  
  getVisitorDetails: async (viewType) => {
    const response = await api.get(`/admin/visitor-details?view=${viewType}`);
    return response.data;
  },
  
  getTodayOrdersDetails: async () => {
    const response = await api.get('/admin/today-orders-details');
    return response.data;
  },
  
  getAllTransactions: async () => {
    const response = await api.get('/admin/transactions');
    return response.data;
  },
  
  approveTransaction: async (transactionId) => {
    const response = await api.put(`/admin/transactions/${transactionId}/approve`);
    return response.data;
  },
  
  rejectTransaction: async (transactionId) => {
    const response = await api.put(`/admin/transactions/${transactionId}/reject`);
    return response.data;
  },
  
  getAllOrders: async () => {
    const response = await api.get('/admin/orders');
    return response.data;
  },
  
  updateOrder: async (orderId, status, notes) => {
    const response = await api.put(`/admin/orders/${orderId}`, { status, notes });
    return response.data;
  },
  
  getAllMessages: async () => {
    const response = await api.get('/admin/messages');
    return response.data;
  },
  
  replyToMessage: async (messageId, adminReply) => {
    const response = await api.put(`/admin/messages/${messageId}/reply`, { adminReply });
    return response.data;
  },
  
  updateMessageStatus: async (messageId, status) => {
    const response = await api.put(`/admin/messages/${messageId}/status`, { status });
    return response.data;
  },
  
  createNotification: async (notificationData) => {
    const response = await api.post('/admin/notifications', notificationData);
    return response.data;
  },
};
